import { styled } from '@mui/system'

export const Grid = styled('div')`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 32px;
    row-gap: 24px;
    width: 100%;
`
